<template>
  <div class="my_container">
    <div class="myTop_content">
      <div class="my_top">
        <div class="top_content"></div>
        <div class="content_bac">
          <div class="headerTop">
            <img :src="user.icon" alt="" />
            <div class="top_userinfo1">
              <div class="nickname">
                {{ user.nickname }}&nbsp;|&nbsp;{{ user.department }}
              </div>
              <!-- <div class="department1">
                <div class="department-dep">{{ user.department }}</div>
              </div> -->
              <div class="badge_content" @click="handleToMyBadge">
                <div
                  class="badge_item"
                  v-for="(item, index) in badgeList"
                  :key="index"
                  :class="
                    index == 0 && item.name
                      ? 'badge_item1'
                      : index == 1 && item.name
                      ? 'badge_item2'
                      : index == 2 && item.name
                      ? 'badge_item3'
                      : ''
                  "
                >
                  <img
                    :src="item.icon"
                    alt=""
                    style="width: 14px; height: 14px"
                    v-if="item.name"
                  />
                  <span class="name">{{ item.name }}</span>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>

          <div class="header_bottom">
            <div
              class="btm_item"
              v-for="(item, index) in integralList"
              :key="index"
              @click="toRank(index)"
            >
              <div class="name">{{ item.name }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>
          <!-- 我相关的 / 我收到的 快捷入口（从首页迁移过来） -->
          <div class="kuakuaka_entries">
            <div
              class="kuakuaka_entry"
              @click="handleKuakuaka(2)"
            >
              我相关的
            </div>
            <div
              class="kuakuaka_entry"
              @click="handleKuakuaka(3)"
            >
              我收到的
            </div>
          </div>
        </div>
      </div>
      <div class="my_bottom">
        <div class="collapse_con">
          <div class="collapse_list" v-if="listTwo1.length > 0">
            <div
              class="collapse_item"
              v-for="(item, index) in listTwo1"
              :key="index"
              @click="handleChack(item)"
            >
              <div class="item">{{ item.create_time }}</div>
              <div class="value" v-if="item.cardType == 9">
                {{ item.sendName }}给您的点赞卡行为点赞了
              </div>
              <div class="value" v-else-if="item.medalPublicName">
                {{ item.medalPublicName }}
              </div>
              <div class="value" v-else>
                {{ `获得“${item.medalName}”徽章${item.point}积分` }}
              </div>
              <div class="radio" v-if="index == 0"></div>
            </div>
          </div>
          <div class="kong_con" v-else>
            <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
            <div class="kong_title kong_title1">您还没有获得任何勋章</div>
            <div class="kong_title">请加油吧～</div>
          </div>
          <!-- <el-tabs
            type="border-card"
            v-model="tabsValue"
            @tab-click="handleTabs"
          >
            <el-tab-pane label="奋斗历程"> </el-tab-pane>
            <el-tab-pane label="点赞消息"> </el-tab-pane>
            <el-tab-pane label="徽章博物馆"></el-tab-pane>
          </el-tabs>
          <div class="tab_pane_wra" v-if="tabsValue == 0 || tabsValue == 1">
            <van-list
              v-model="loadingTwo"
              :finished="finishedTwo"
              finished-text="没有更多了"
              @load="onLoadTwo"
              :immediate-check="false"
            >
              <div
                class="tab_pane_con"
                v-for="(item, index) in listTwo1"
                :key="index"
              >
                <div class="line">
                  <div class="line1"></div>
                </div>
                <div class="right_con">
                  <div class="title_date">{{ item.createDateFormat }}</div>
                  <el-collapse>
                    <el-collapse-item
                      v-if="tabsValue == 0"
                      :title="
                        item.type == 0
                          ? `获得点赞卡${item.point}积分`
                          : `获得“${item.medalName}”徽章${item.point}积分`
                      "
                      name="1"
                    >
                      <div>
                        {{ item.reason }}
                      </div>
                    </el-collapse-item>
                    <el-collapse-item
                      v-if="tabsValue == 1"
                      :title="
                        item.type == 0
                          ? `获得1个点赞卡点赞`
                          : `获得1个徽章卡点赞`
                      "
                      name="1"
                    >
                      <div>感谢赠送的卡片，给你点个赞。</div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
            </van-list>
          </div>
          <div class="content_list" v-if="tabsValue == 2">
            <div
              class="list_item"
              v-for="(item, index) in badgeInfoList"
              :key="index"
            >
              <div class="item_header">
                <div class="item_title">{{ item.medalTypeName }}</div>
              </div>
              <div class="item_con">
                <div
                  class="badge_item"
                  v-for="(badge, ind) in item.medals"
                  :key="ind"
                  @click="handleBadge(item, badge)"
                >
                  <img :src="imgUrl + badge.iconId" alt="" />
                  <div class="badge_tit">{{ badge.medalName }}</div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <van-dialog
      class="dialog"
      v-model="showTip"
      :showConfirmButton="false"
      z-index="1999"
    >
      <div class="dialog_header">
        <div></div>
        <div class="dialog_title">徽章赠送</div>
        <div>
          <van-icon name="cross" @click="handelNo" />
        </div>
      </div>
      <van-form label-width="70" label-align="right">
        <van-field
          v-model="form.cardName"
          name="卡片类型"
          label="卡片类型："
          placeholder="卡片类型"
          readonly
        />

        <van-field
          v-model="form.medalName"
          name="关键词"
          label="关键词："
          placeholder="请选择关键词"
        >
        </van-field>
        <van-field
          v-model="form.point"
          name="分值"
          label="分值："
          placeholder="分值"
          readonly
        />
        <van-field name="赠送人" label="赠送人：" placeholder="请输入赠送人">
          <template #input>
            <el-select
              v-model="form.reciverEmpno"
              placeholder="请输入赠送名字"
              clearable
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select"
              @blur.native.capture="onblur"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <van-field name="抄送人" label="抄送人：" placeholder="抄送人">
          <template #input>
            <el-select
              v-model="form.ccEmpno"
              placeholder="请选择抄送人"
              multiple
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select2"
              @blur.native.capture="onblur2"
              @hook:mounted="cancalReadOnly2"
              @visible-change="cancalReadOnly2"
            >
              <el-option
                v-for="item in options"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </template>
        </van-field>
        <div class="dialog-reason">
          <div>
            <van-field
              v-model="form.reason"
              rows="2"
              autosize
              label="赠送理由："
              type="textarea"
              maxlength="200"
              placeholder="请输入赠送理由"
              show-word-limit
            />
          </div>
        </div>
      </van-form>

      <div class="dialog-btn">
        <el-button @click="handelNo">取消</el-button>
        <el-button
          @click="handelOk"
          style="background: rgba(72, 158, 108, 1); color: #fff"
          :disabled="isDisabled"
          v-loading="isDisabled"
          >确认</el-button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
// import moment from "moment";
export default {
  name: "facility",
  props: {},

  data() {
    return {
      user: {},
      total: "",
      tabsValue: "",
      badgeList: [
        {
          icon: require("@/assets/newsNotice/icon1.png"),
          name: ""
        },
        {
          icon: require("@/assets/newsNotice/icon2.png"),
          name: ""
        },
        {
          icon: require("@/assets/newsNotice/icon3.png"),
          name: ""
        }
      ],
      integralList: [
        {
          value: "0",
          name: "本月收获"
        },
        {
          value: "0",
          name: "部门排行"
        },
        {
          value: "0",
          name: "集团排行"
        }
      ],
      listTwo1: [],
      loadingTwo: false,
      finishedTwo: false,
      totalAllTwo1: 0,
      pageTwo: 1,
      empno: "",
      pageSize: 20,
      badgeInfoList: [],
      imgUrl: "",
      showTip: false,
      form: {
        cardName: "",
        cardId: "",
        point: "",
        senderEmpno: "",
        reciverEmpno: "",
        ccEmpno: [],
        medalId: "",
        medalName: ""
      },
      isDisabled: false,
      loadingSelect: false,
      options: []
    };
  },

  created() {
    this.user = this.$store.state.userInfo;
  },
  computed: {},
  mounted() {
    // this.isShow = this.$store.state.userInfo.hr == '0' ? false : true;//0 不显示 1 显示
    this.imgUrl = api.imgUrl;
    let hrToken = getToken();
    //获取token
    if (hrToken) {
      this.empno = hrToken;
      this.getLastThreeMedals(hrToken);
      this.getInfo(hrToken);
      this.getBadgeListTwo();
      // this.likeLog();
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getLastThreeMedals(res);
          this.getInfo(res);
          this.getBadgeListTwo();
          // this.likeLog();
        });
      });
    }
  },
  methods: {
    // 跳转到点赞卡页面（从首页迁移过来）
    handleKuakuaka(type) {
      localStorage.removeItem("quaActive");
      localStorage.setItem("tabsActive", 1);
      this.$router.push(`/mobile/medal/quaquaka?type=${type}`);
    },
    // 获取token&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },

    // 获取最近三个勋章
    getLastThreeMedals(empno) {
      api.getLastThreeMedalsApi({ empno }).then(res => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            this.badgeList[index].name = item.medalName;
          });
        }
      });
    },
    // 获取个人徽章信息
    getInfo(empno) {
      api
        .myRankingApi({ empno, hrAuthToken: window.sessionStorage.hrToken })
        .then(res => {
          this.integralList = [
            {
              value: res.data.thisMonthCount + "枚",
              name: "本月收获"
            },
            {
              value: res.data.levelOneDeptRank,
              name: "部门排行"
            },
            {
              value: res.data.companyRank,
              name: "集团排行"
            }
          ];
        });
    },
    // tab切换
    handleTabs() {
      this.totalAllTwo1 = 0;
      this.pageTwo = 1;
      this.listTwo1 = [];
      this.loadingTwo = false;
      this.finishedTwo = false;
      if (this.tabsValue == 0) {
        this.getBadgeListTwo();
      } else if (this.tabsValue == 1) {
        this.likeLog();
      } else {
        this.queryMedalCardAll();
      }
    },
    // 获取徽章
    onLoadTwo() {
      if (this.tabsValue == 0) {
        this.getBadgeListTwo();
      } else if (this.tabsValue == 1) {
        this.likeLog();
      }
    },
    // 获取徽章&点赞卡积分列表
    getBadgeListTwo() {
      api
        .fightProcessAPi({
          page: this.pageTwo,
          pageSize: this.pageSize,
          flagType: "1",
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken
        })
        .then(res => {
          if (res.code == 200) {
            this.totalAllTwo1 = res.total;
            this.finishedTwo = false;
            if (this.pageTwo === 1) {
              this.listTwo1 = res.data;
            } else {
              this.listTwo1 = this.listTwo1.concat(res.data);
            }
            if (this.listTwo1.length < this.totalAllTwo1) {
              this.pageTwo = this.pageTwo + 1;
            } else {
              this.finishedTwo = true;
            }
            this.loadingTwo = false;
          }
        });
    },
    // 获取点赞
    likeLog() {
      api
        .likeLogApi({
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken
        })
        .then(res => {
          if (res.code == 200) {
            this.totalAllTwo1 = res.total;
            this.finishedTwo = false;
            if (this.pageTwo === 1) {
              this.listTwo1 = res.data;
            } else {
              this.listTwo1 = this.listTwo1.concat(res.data);
            }
            if (this.listTwo1.length < this.totalAllTwo1) {
              this.pageTwo = this.pageTwo + 1;
            } else {
              this.finishedTwo = true;
            }
            // this.listTwo1.forEach(item => {
            //   item.createDateFormat = moment(item.created).format("YYYY-MM-DD");
            // });
            this.loadingTwo = false;
          }
        });
    },
    // 获取徽章列表
    queryMedalCardAll() {
      api.medalCardAllApi({ empno: this.empno }).then(res => {
        if (res.code == 200) {
          this.badgeInfoList = res.data;
        }
      });
    },
    // 赠送徽章
    handleBadge(item, badge) {
      if (badge.flagType == 2) {
        return this.$message({
          message: "该徽章只能系统赠送",
          type: "warning"
        });
      } else if (badge.flagType == 3) {
        return this.$message({
          message: "该徽章此处无法赠送",
          type: "warning"
        });
        // if (this.$store.state.userInfo.hr == 1) {
        //   this.form.cardName = item.medalTypeName;
        //   this.form.medalName = badge.medalName;
        //   this.form.medalId = badge.id;
        //   this.form.point = badge.point;
        //   this.showTip = true;
        // } else {
        //   return this.$message({
        //     message: "对不起，该徽章您没有权限赠送",
        //     type: "warning"
        //   });
        // }
      } else {
        this.form.cardName = item.medalTypeName;
        this.form.medalName = badge.medalName;
        this.form.medalId = badge.id;
        this.form.point = badge.point;
        this.showTip = true;
      }
    },
    // 取消赠送
    handelNo() {
      this.showTip = false;
      this.form = {};
    },
    // 确认赠送
    handelOk() {
      if (!this.form.medalId) {
        return this.$message({
          message: "请选择关键词",
          type: "warning"
        });
      }
      if (!this.form.reciverEmpno) {
        return this.$message({
          message: "请选择赠与人",
          type: "warning"
        });
      }
      if (!this.form.reason) {
        return this.$message({
          message: "请输入赠送理由",
          type: "warning"
        });
      }
      this.isDisabled = true;
      const json = {
        medalId: this.form.medalId,
        receiverEmpno: this.form.reciverEmpno,
        ccEmpno: this.form.ccEmpno.join(","),
        reason: this.form.reason,
        senderEmpno: this.$store.state.userInfo.username,
        cardId: this.$route.query.id
      };
      api.medalCardSendApi(json).then(res => {
        if (res.code == 200) {
          this.showTip = false;
          this.$message({
            message: "赠送成功",
            type: "success"
          });
          // this.$router.back();
        }
        this.isDisabled = false;
      });
    },
    // 查询 抄送人
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value
        })
        .then(data => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },

    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    // 在苹果手机上唤起键盘
    onblur2() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select2.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly2(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select2 } = this.$refs;
          const input = select2?.$el.querySelector(".el-input__inner");
          input?.removeAttribute("readonly");
        }
      });
    },
    // 跳转荣誉墙
    handleToMyBadge() {
      this.$router.push("/mobile/medal/myBadgeList");
    },
    //查看徽章&点赞卡详情
    handleChack(item) {
      console.log(item);

      if (item.cardType == 1 || item.cardType == 9) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: item.id
          }
        });
      }
    },
    //跳转排行榜
    toRank(index) {
      if (index == 0) {
        this.$router.push({
          path: "/mobile/medal/myBadgeList"
        });
      }else if (index == 1) {
        this.$router.push({
          path: "/mobile/medal/rankList",
          query: {
            newValue: this.$store.state.userInfo.departmentCode.slice(0, 3)
          }
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/mobile/medal/rankList",
          query: {
            newValue: "1"
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .my_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .my_container {
    width: 276px * $zoom;
  }
}

.my_container {
  // height: 100%;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #ffffff;
  overflow: hidden;
  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .my-swipe {
    margin-bottom: 1vh;
  }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }

  .car-foot {
    padding: 0 30px;
  }

  .car-foot-nav {
    width: 47%;
    height: 200px;
    background: #fff;
    font-size: 29px;
    font-weight: bold;
    // border-radius: 20px;
    margin: 30px 0 0 0;
    padding: 20px;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  .myTop_content {
    height: calc(100vh - 130px);
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
  .footer_con {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 28px;
    height: 120px;
    width: 100%;
    .footer_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .label {
        font-weight: 400;
        color: #666666;
      }
      .activeLabel {
        font-weight: 500;
        color: #4ea27c;
      }
    }
  }
  .my_top {
    position: relative;
    height: 700px;
    // background-image: url("../../../assets/newsNotice/background1.png");
    // background-size: 100% 100%;
    padding-top: 1px;
    .top_content {
      // background: #ffffff;
      // box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.14);
      // border-radius: 10px;
      // opacity: 0.65;
      // backdrop-filter: blur(8px);
      margin: 40px 40px 0 40px;

      width: 90%;
      height: 290px;
    }
    .content_bac {
      width: 90%;
      position: absolute;
      top: 60px;
      left: 45px;
    }
    .headerTop {
      display: flex;
      align-content: center;
      // padding: 10px 30px 0 30px;
      img {
        width: 78px;
        height: 78px;
        border-radius: 50%;
        // margin-top: -40px;
      }

      .top_userinfo1 {
        width: 100%;
        margin-left: 35px;
        position: relative;
        .nickname {
          display: flex;
          align-items: center;
          font-size: 32px;
          color: rgba(61, 61, 61, 1);
          font-weight: 600;
          margin-bottom: 10px;
        }

        .department1 {
          display: flex;
          align-items: center;
          font-size: 22px;

          img {
            width: 40px;
            height: 40px;
          }

          .department-dep {
            margin-right: 10px;
          }

          .department-dis {
            display: flex;
            align-items: center;

            img {
              width: 26px;
              height: 20px;
            }

            span {
              // margin-left: 8px;
              color: #f81a1a;
              font-size: 29px;
            }
          }
        }
      }
    }
    .badge_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;
      display: flex;
      i {
        font-size: 38px;
      }
      // justify-content: space-around;
      .badge_item {
        font-size: 22px;
        border-radius: 22px;
        padding: 10px 15px;
        display: flex;
        align-items: center;
        // margin-top: 15px;
        // margin-left: 30px;
        .name {
          margin-left: 10px;
        }
      }
      .badge_item1 {
        background: #faf7ea;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #ff9347;
      }
      .badge_item2 {
        background: #f2f7fc;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #666666;
      }
      .badge_item3 {
        background: #f8f6f4;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.06);
        color: #b97e61;
      }
      .opImg {
        opacity: 0;
      }
      .oImg {
        opacity: 1;
      }
    }
    .header_bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 40px;
      .btm_item {
        display: flex;
        align-items: center;
        .value {
          font-weight: 600;
          font-size: 32px;
          color: #191b28;
          text-align: center;
          margin-left: 20px;
        }
        .name {
          font-weight: 400;
          font-size: 22px;
          color: #999999;
        }
      }
    }
    .kuakuaka_entries {
      display: flex;
      justify-content: space-around;
      margin-top: 30px;
      .kuakuaka_entry {
        flex: 1;
        text-align: center;
        font-weight: 500;
        font-size: 26px;
        color: #489e6c;
        padding: 16px 0;
        margin: 0 12px;
        background: rgba(72, 158, 108, 0.1);
        border-radius: 12px;
      }
    }
  }
  .my_bottom {
    width: 100%;
    padding: 0 40px 0 40px;
    display: flex;
    position: absolute;
    top: 420px;
    height: calc(100vh - 580px);
    overflow: auto;
    z-index: 9;
    &::-webkit-scrollbar {
      display: none;
    }
    .collapse_con {
      width: 100%;
      .collapse_item:nth-child(1) {
        background: rgba($color: #fff, $alpha: 1);
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.05);
        position: relative;
      }
      .radio {
        position: absolute;
        top: 30px;
        right: 30px;
        width: 30px;
        height: 30px;
        background: #1bba84;
        border-radius: 50%;
      }
      .collapse_item {
        background: rgba($color: #fff, $alpha: 0.36);
        padding: 40px;
        font-size: 30px;
        color: #666666;
        border-radius: 30px;
        margin-bottom: 30px;
        .value {
          font-size: 32px;
          font-weight: bold;
          color: #191b28;
          margin-top: 20px;
        }
      }
      .kong_con {
        width: 100%;
        height: 60%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 50px;
        justify-content: center;
        .kong_img {
          width: 450px;
          height: 450px;
        }
        .kong_title1 {
          margin-top: 30px !important;
        }
        .kong_title {
          color: #999999;
          font-size: 26px;
          margin-top: 10px;
        }
      }
    }
    ::v-deep {
      .el-tabs--border-card {
        border: 0;
        box-shadow: initial;
      }
      .el-tabs {
        width: 100%;
        margin-left: 0 7%;
        background-color: #fff;
        display: flex;
        justify-content: space-around;
      }
      .el-tabs__content {
        padding: 0;
        height: 0;
      }
      .el-collapse-item__header {
        border: 0;
      }
      .el-collapse-item__wrap {
        border: 0;
      }
      .el-tabs--border-card > .el-tabs__header {
        border: 0;
        background-color: #f0f5f7;
        border-radius: 30px;
      }
      .el-collapse {
        border: 0;
      }
      .el-collapse-item__header {
        font-weight: 500;
        font-size: 28px;
        color: #191b28;
      }
      .el-tabs__item {
        // width: 200px;
        border: 0;
        box-shadow: initial;
        // border-radius:30px 30px 30px 0;
        &:hover {
          color: initial;
        }
      }
      .el-tabs__item.is-active {
        font-weight: 600;
        font-size: 26px;
        color: #191b28;
        position: relative;
        border-radius: 30px 30px 0 0;
        z-index: 99;
        text-align: center;
        &::after {
          content: "";
          display: block;
          width: 50%;
          height: 14px;
          background: linear-gradient(90deg, #4ea27c 0%, #aaecce 100%);
          border-radius: 5px;
          position: absolute;
          top: 50px;
          left: 50%;
          transform: translate(-50%, -50%);
          opacity: 0.8;
        }
      }
    }
    .tab_pane_wra {
      height: calc(100vh - 600px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .tab_pane_con {
      position: relative;
      display: flex;
      .right_con {
        padding-top: 1px;
        padding-left: 40px;
        width: 100%;
        .title_date {
          font-weight: 500;
          font-size: 30px;
          color: #666666;
          height: 70px;
          line-height: 90px;
        }
        ::v-deep {
          .el-collapse-item__header {
            font-weight: bold;
            font-size: 28px;
            color: #191b28;
          }
        }
      }
      .line {
      }
      .line1 {
        width: 20px;
        height: 20px;
        background: #4ea27c;
        border: 2px solid #f7f9fa;
        border-radius: 50%;
        margin: 0 20px;
        display: flex;
        flex-shrink: 0;
      }
      .line::after {
        display: inline-block;
        content: "";
        width: 1px;
        height: 100%;
        background-color: #ccc;
        position: relative;
        left: 48%;
      }
      .line::before {
        display: inline-block;
        content: "";
        width: 1px;
        height: 35px;
        background-color: #ccc;
        position: relative;
        left: 48%;
      }
    }
    .collapse_con .tab_pane_con:first-child {
      .line::before {
        background: #fff;
      }
    }
    .content_list {
      width: 100%;
      height: calc(100vh - 600px);
      overflow-y: auto;
      padding: 0 30px;
      border-radius: 16px;
      background-color: #fff;
      box-shadow: 0px -3px 7px 0px rgba(0, 0, 0, 0.04);
      border-radius: 54px 54px 0px 0px;
      &::-webkit-scrollbar {
        display: none;
      }
      .list_item {
        .item_header {
        }
        .item_title {
          font-weight: 600;
          font-size: 29px;
          color: #282b32;
          margin: 40px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          &::before {
            content: "";
            display: inline-block;
            width: 38px;
            height: 18px;
            background-image: url("~@/assets/newsNotice/icon12.png");
            background-size: 100% 100%;
            margin-right: 20px;
          }
          &::after {
            content: "";
            display: inline-block;
            width: 38px;
            height: 18px;
            background-image: url("~@/assets/newsNotice/icon13.png");
            background-size: 100% 100%;
            margin-left: 20px;
          }
        }
        .item_con {
          display: flex;
          flex-wrap: wrap;
          .badge_item {
            width: 33.33%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 50px;
            img {
              width: 146px;
              height: 146px;
            }
            .badge_tit {
              font-weight: 500;
              font-size: 27px;
              color: #191b28;
              margin: 10px 0;
            }
            .sub_tit {
              font-weight: 400;
              font-size: 22px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}
.dialog {
  // height: 218px * $zoom;
  padding: 30px;
  .dialog_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 32px;
    color: #282b32;
  }

  .dialog-people {
    margin-bottom: 30px;
  }
  ::v-deep {
    .van-cell::after {
      border: 0;
    }
    .el-input__inner {
      border: 0;
      background: #f7f9fa;
      border-radius: 10px;
    }
  }
  .dialog-reason {
    ::v-deep {
      .van-cell {
        // background: rgba(244, 244, 244, 1);
        display: flex;
        flex-direction: column;
      }

      .van-field__control {
        // height: 200px !important;
      }
      .van-field__value {
        background: rgba(244, 244, 244, 1);
        padding: 20px 20px;
        border-radius: 10px;
        margin-top: 20px;
      }
    }
  }

  ::v-deep {
    .el-input__inner {
      min-height: 22px * $zoom !important;
    }
  }

  .cc {
    ::v-deep {
      .el-select__tags {
        max-width: none !important;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 30px;
    width: 100%;

    button {
      width: 200px;
      height: 80px;
      border-radius: 40px;
      font-size: 28px;
    }
  }
}
</style>
